export const ROLES = {
    ADMINISTRADOR_FIDUCIARIO: "administrador_fiduciario",
    OPERACIONES: "operaciones",
    TESORERIA: "tesoreria",
    FINANZAS: "finanzas",
    JURIDICO: "juridico",
    CUMPLIMIENTO: "cumplimiento",
    RIESGOS: "riesgos",
    DIRECCION: "direccion",
    AUDITOR: "auditor",
    PARTE_EXTERNA: "parte_externa",
    ADMIN_TI: "admin_ti",
    // Fase 14 · Gobierno Fiduciario
    DELEGADO_FIDUCIARIO: "delegado_fiduciario",
    CONSEJO: "consejo",
};

export const ROLE_LABELS = {
    administrador_fiduciario: "Administrador Fiduciario",
    operaciones: "Operaciones",
    tesoreria: "Tesorería",
    finanzas: "Finanzas / Contabilidad",
    juridico: "Jurídico",
    cumplimiento: "Cumplimiento / PLD",
    riesgos: "Riesgos / UAIR",
    direccion: "Dirección",
    auditor: "Auditor / Calificadora",
    parte_externa: "Parte Externa (Portal)",
    admin_ti: "Admin TI",
    delegado_fiduciario: "Delegado Fiduciario",
    consejo: "Consejo (Órgano de Gobierno)",
};

export const ALL_ROLES = Object.values(ROLES);
